// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"73c1e656","116":"ba4b2fee","149":"e780118f","399":"90412b07","447":"ac594aa9","671":"b11c5b44","730":"af2ec763","830":"5e11b380","953":"57adbce2"}[chunkId] + ".chunk.css";
};